module.exports = __webpack_public_path__ + "static/img/initNoData.02e3a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pubmedSearch/initNoData.png
// module id = KBje
// module chunks = 1